import type { CSSProperties } from "react";

// Overflow for the page-content scroll container beside the chat drawer.
// The drawer is a flex sibling that pushes the content; a page that opts
// out of vertical scrolling here (builders manage their own scroll regions)
// must still let content that cannot shrink any further scroll
// horizontally — never be clipped behind the drawer's edge.
export const pageContentOverflowStyle = (
  overflow: CSSProperties["overflow"],
): CSSProperties => ({
  overflowY: overflow as CSSProperties["overflowY"],
  overflowX: "auto",
});
